import React from "react";
import { useState, useRef, useEffect } from "react";
import { apiURL } from "../../config";
import PromptText from "./bottomText";
import SubmitButton from "./submitButton";
import { useSelector, useDispatch } from "react-redux";
import { setConversationId } from "../../redux/conversationIdSlice";
import {
  messagesAppend,
  lastMessageAppend,
  lastMessageReplace,
} from "../../redux/messagesSlice";
import {
  conversationsAdd,
  conversationTitleUpdate,
} from "../../redux/conversationsSlice";
import { archiveImage, deleteImage } from "../../redux/imagesSlice";
import { getSelectedTemplate } from "../../redux/selectors";
import { setPrompt } from "../../redux/promptSlice";
import { setModelPanel } from "../../redux/modelPanelSlice";
import ModelDropDown from "./ModelDropDown";
import closeSVG from "../svg/closeSVG";
import visionSVG from "../svg/visionSVG";
import { setMessagesStatus } from "../../redux/messagesStatusSlice";

function PromptForm() {
  const conversationId = useSelector((state) => state.conversationId);
  const dispatch = useDispatch();
  const sideBarState = useSelector((state) => state.sideBar);
  const modelPanelState = useSelector((state) => state.modelPanel);
  const user = useSelector((state) => state.user);
  const messages = useSelector((state) => state.messages);
  const models = useSelector((state) => state.models);
  const prompt = useSelector((state) => state.prompt);
  const model = useSelector((state) => state.model);
  const conversations = useSelector((state) => state.conversations);
  const conversationStartIndex = useSelector(
    (state) => state.conversationStartIndex
  );
  const [isSending, setIsSending] = useState(false);
  const textareaRef = useRef();
  const images = useSelector((state) => state.images).filter(
    (image) => !image.deleted && !image.archived
  );
  const { systemText, templateMessage } = useSelector(getSelectedTemplate);
  const selectedTemplate = useSelector(
    (state) => state.templates.selectedTemplate
  );
  const modelPanel = useSelector((state) => state.modelPanel);

  let allowSubmit = prompt.trim() !== "" && !isSending;
  for (let image of images) {
    if (image.status !== "success") {
      allowSubmit = false;
      break;
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (allowSubmit) {
      dispatch(setMessagesStatus("SUCCESS"));
      dispatch(setPrompt(templateMessage ?? ""));
      setIsSending(true);
      let newMessage = {};
      const imagesActive = images.filter(
        (image) => image.archived === false && image.deleted === false
      );
      if (models[model]?.vision && imagesActive.length > 0) {
        newMessage = { role: "user", content: [], attachments: true };
        for (let image of images) {
          newMessage.content.push({ type: "image", imageId: image.imageId });
          dispatch(archiveImage({ url: image.url, archive: true }));
        }
        newMessage.content.push({ type: "text", text: prompt });
        newMessage.content = JSON.stringify(newMessage.content);
      } else {
        newMessage = { role: "user", content: prompt, attachments: false };
      }
      // dispatch(messagesAppend({ role: "user", content: prompt }));
      dispatch(messagesAppend(newMessage));
      const convMessages = [
        ...messages.slice(conversationStartIndex),
        newMessage,
      ];
      let url = `${apiURL}/api/message`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          convMessages,
          browsing: false,
          model,
          systemText,
          conversationId,
          selectedTemplate,
        }),
        credentials: "include",
      });

      // if (!response.ok) {
      //   console.log("response not ok");
      //   setMessages([
      //     ...newMessages,
      //     { role: "assistant", content: "Error sending message" },
      //   ]);
      // }

      let buffer = "";

      const reader = response.body.getReader();
      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          console.log("done", done);
          break;
        }
        const valueStr = new TextDecoder().decode(value, { stream: true });
        // console.log("valueStr", valueStr);
        buffer += valueStr;
        const pStart = "data:::";
        const pEnd = ":::atad";
        let jsonIndexes = findPartsIndexes(pStart, pEnd, buffer);
        for (let i = 0; i < jsonIndexes.length; i++) {
          const jsonStr = buffer.slice(jsonIndexes[i][0], jsonIndexes[i][1]);
          const valueObj = JSON.parse(jsonStr);
          switch (valueObj.type) {
            case "DONE":
              break;
            case "CID":
              if (valueObj.cid !== conversationId) {
                dispatch(setConversationId(valueObj.cid));
                dispatch(
                  conversationsAdd({
                    _id: valueObj.cid,
                    title: "New Conversation",
                  })
                );
              }
              break;
            case "TITLE":
              dispatch(
                conversationTitleUpdate({
                  _id: valueObj.cid,
                  title: valueObj.title,
                })
              );
              if (user.username === "") {
                const newConversations = [
                  { _id: valueObj.cid, title: valueObj.title },
                  ...conversations,
                ];
                localStorage.setItem(
                  "conversations",
                  JSON.stringify(newConversations)
                );
              }
              break;
            case "BEGIN":
              dispatch(
                messagesAppend({
                  role: "assistant",
                  model: model,
                  content: "",
                })
              );
              break;
            case "COMPLETE":
              dispatch(lastMessageReplace(valueObj.contentAll));
              break;
            case "APPEND":
              dispatch(lastMessageAppend(valueObj.content));
              break;
            case "ERROR":
              dispatch(lastMessageReplace("Error sending message"));
              break;
            default:
              console.log("switch no matches");
              console.log(valueObj);
          }
        }
        if (jsonIndexes.length > 0) {
          buffer = buffer.slice(
            jsonIndexes[jsonIndexes.length - 1][1] + pEnd.length
          );
        }
      }
      setIsSending(false);
    }
  };

  const handleImage = () => {
    const event = new CustomEvent("triggerFileInput", {
      detail: {
        action: "open",
      },
    });
    window.dispatchEvent(event);
  };

  return (
    <div
      className={`fixed bottom-0  px-4  ${
        sideBarState === "left-sidebar" ? "left-52" : "left-0"
      } ${modelPanelState === "right" ? "right-[328px]" : "right-0"}`}
      id="bottomDiv"
    >
      <form name="formInput" method="post" onSubmit={handleSubmit}>
        <div className="w-full min-h-[4rem] relative bg-[hsla(var(--bg-000))] text-white rounded-t-xl pl-4 pr-10 py-2 shadow-[0_0.25rem_1.25rem_rgba(0,0,0,0.05),0_0_0.75rem_0.5rem_hsl(var(--bg-100))] border-t-[0.5px] border-x-[0.5px] border-[hsla(var(--border-100)/0.8)]">
          {models[model]?.vision && <ImagesPreview />}
          <PromptText
            textareaRef={textareaRef}
            handleSubmit={handleSubmit}
            allowSubmit={allowSubmit}
          />
          <ModelShortCut models={models} model={model} />
          <div className="absolute   right-1 top-1 flex items-center justify-center p-2">
            <SubmitButton
              handleSubmit={handleSubmit}
              allowSubmit={allowSubmit}
            />
          </div>
          {models[model]?.vision && (
            <div
              className="absolute  right-2 bottom-1 flex items-center justify-center p-1 cursor-pointer hover:scale-110"
              onClick={handleImage}
            >
              <div className="w-6 h-6 opacity-90">{visionSVG("white")}</div>
            </div>
          )}
          {modelPanel === "hidden-bottom" && <UpArrow />}
        </div>
      </form>
    </div>
  );
}

const ImagesPreview = function () {
  const images = useSelector((state) => state.images).filter(
    (image) => !image.deleted && !image.archived && image.status === "success"
  );
  const dispatch = useDispatch();
  if (images.length === 0) {
    return null;
  }
  const handleDeleteImage = (url) => {
    dispatch(deleteImage(url));
  };
  return (
    <div className="flex flex-row gap-2 overflow-x-scroll w-full py-2">
      {images.map((image, index) => (
        <div key={image.url} className="relative flex-none">
          <img
            src={image.url}
            alt={`upload-preview-${index}`}
            className="w-20 h-20 object-cover rounded-lg"
          />
          <button
            onClick={() => handleDeleteImage(image.url)}
            className="absolute rounded-full bg-red-500 w-4 h-4 -top-1 -right-1  cursor-pointer"
          >
            {closeSVG}
          </button>
        </div>
      ))}
    </div>
  );
};

const ModelShortCut = function ({ models, model }) {
  const [show, setShow] = useState(false);
  const dropDownButtonRef = useRef();
  const [dropDownHeight, setDropDownHeight] = useState("200px");

  const handleClick = () => {
    if (dropDownButtonRef.current) {
      const rect = dropDownButtonRef.current.getBoundingClientRect();
      const spaceAbove = Math.floor(rect.top - 60);
      setDropDownHeight(`${spaceAbove}px`);
    }
    setShow(!show);
  };

  // handle click outside the dropdown
  const handleClickOutside = (event) => {
    if (
      dropDownButtonRef.current &&
      !dropDownButtonRef.current.contains(event.target)
    ) {
      setShow(false);
    }
  };

  // add event listener when component mounts
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className="relative w-fit  flex items-center select-none"
      ref={dropDownButtonRef}
      onClick={handleClick}
    >
      <div className="group w-fit  font-serif text-sm text-gray-300  cursor-pointer relative py-1 pr-6 rounded-full hover:[text-shadow:_#FC0_0px_0px_6px]">
        {models[model]?.longName ?? "Model not found"}
        <ModelSVG />
      </div>

      <ModelDropDown
        show={show}
        setShow={setShow}
        dropDownHeight={dropDownHeight}
        position="bottom"
      />
    </div>
  );
};

const ModelSVG = function () {
  return (
    <div className="absolute right-2 top-[52%] -translate-y-1/2 group-hover:animate-bounce-once">
      <svg
        width="9"
        height="9"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="rotate-180 opacity-50"
      >
        <g id="SVGRepo_iconCarrier">
          {" "}
          <path
            d="M19 9L14 14.1599C13.7429 14.4323 13.4329 14.6493 13.089 14.7976C12.7451 14.9459 12.3745 15.0225 12 15.0225C11.6255 15.0225 11.2549 14.9459 10.9109 14.7976C10.567 14.6493 10.2571 14.4323 10 14.1599L5 9"
            stroke="hsla(var(--text-100)/0.8)"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>{" "}
        </g>
      </svg>
    </div>
  );
};

function findPartsIndexes(start, end, string) {
  const indexes = [];
  let startIndex = string.indexOf(start);

  while (startIndex !== -1) {
    const endIndex = string.indexOf(end, startIndex + start.length);

    if (endIndex !== -1) {
      indexes.push([startIndex + start.length, endIndex]);
      startIndex = string.indexOf(start, endIndex + end.length);
    } else {
      break;
    }
  }

  return indexes;
}

function UpArrow() {
  const dispatch = useDispatch();
  return (
    <div
      className="absolute top-1 -translate-y-1/2  left-1/2 -translate-x-1/2"
      onClick={() => {
        dispatch(setModelPanel("bottom"));
      }}
    >
      <svg
        width="40px"
        height="40px"
        viewBox="-2.5 -2.5 30.00 30.00"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke="#fa0000"
        transform="rotate(0)matrix(1, 0, 0, 1, 0, 0)"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="#CCCCCC"
          strokeWidth="0.2"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <path
            d="M12 22.4199C17.5228 22.4199 22 17.9428 22 12.4199C22 6.89707 17.5228 2.41992 12 2.41992C6.47715 2.41992 2 6.89707 2 12.4199C2 17.9428 6.47715 22.4199 12 22.4199Z"
            stroke="hsla(0, 0%, 100%, 0.2)"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>{" "}
          <path
            d="M8 13.8599L10.87 10.8C11.0125 10.6416 11.1868 10.5149 11.3815 10.4282C11.5761 10.3415 11.7869 10.2966 12 10.2966C12.2131 10.2966 12.4239 10.3415 12.6185 10.4282C12.8132 10.5149 12.9875 10.6416 13.13 10.8L16 13.8599"
            stroke="#828282"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>{" "}
        </g>
      </svg>
    </div>
  );
}

export default PromptForm;
